/* eslint-disable func-names */
(function ($) {
  /* sets identifier classes, needed when both firstname and lastname input is available */
  if ($('.form.hearing-test .scfSectionBorder .scfSectionContent').length) {
    $('.form.hearing-test .scfSectionBorder .scfSectionContent > div:first-child .scfSingleLineGeneralPanel, .form.hearing-test .scfSectionBorder .scfSectionContent > div:first-child() .scfSingleLineTextLabel').addClass('firstName');
    $('.form.hearing-test .scfSectionBorder .scfSectionContent > div:nth-child(2) .scfSingleLineGeneralPanel, .form.hearing-test .scfSectionBorder .scfSectionContent > div:nth-child(2) .scfSingleLineTextLabel').addClass('lastName');
  }
  var $inputs = $('.form.hearing-test .scfSectionBorder .scfSectionContent input');
  var $labels = $('.form.hearing-test .scfSectionBorder .scfSectionContent label');
  $inputs.each(function (index) {
    var $this = $(this);
    var $label = $($labels[index]);
    $this.attr('placeholder', $label.text());
    $label.hide();

    /* Removes previously entered text in input fields on load (Needed if user is going backwards from another step) */
    $this.val('').blur();
  });
  $(document).ready(function () {
    if ($('.scfForm .scfValidationSummary > ul li span').length) {
      var $ErrorStarSpan = $('.scfForm .scfValidationSummary > ul li');
      $ErrorStarSpan.append('<div class="ErrorStar">*</div>');
    }
  });
  $(' .form.hearing-test .scfValidationSummary ul').append('<li></li>');
  $(' .form.hearing-test .scfValidatorRequired').appendTo('.scfValidationSummary ul li:last-of-type()');
})(jQuery);